import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/service-cases/$id/')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: `/service-cases/${params.id}/overview`,
    })
  },
})
